import React, { Children, Fragment, forwardRef } from 'react';
import cn from 'bem-cn';

import { StackProps } from './Stack.types';
import './Stack.scss';

const b = cn('stack');

export const Stack = forwardRef<HTMLDivElement, StackProps>(
    (
        {
            children,
            as: Component = 'div',
            direction = 'column',
            spacing,
            justifyContent,
            alignItems,
            className,
            px,
            py,
            style,
            divider,
            role,
            title,
            onClick,
        },
        ref,
    ) => {
        const childrenArray = Children.toArray(children);

        const stackStyle: React.CSSProperties = {
            ...style,
            flexDirection: direction,
            gap: !spacing && spacing !== 0 ? undefined : `${spacing}px`,
            justifyContent,
            alignItems,
        };

        if (px !== undefined) {
            stackStyle.paddingLeft = `${px}px`;
            stackStyle.paddingRight = `${px}px`;
        }
        if (py !== undefined) {
            stackStyle.paddingTop = `${py}px`;
            stackStyle.paddingBottom = `${py}px`;
        }

        // Если есть divider, вставляем его между элементами
        const content = divider
            ? childrenArray.map((child, index) => (
                <Fragment key={index}>
                    {child}
                    {index < childrenArray.length - 1 && <div className={b('divider')}>{divider}</div>}
                </Fragment>
            ))
            : childrenArray;

        return (
            <Component
                ref={ref}
                className={b({ direction }).mix(className)}
                style={stackStyle}
                role={role}
                title={title}
                onClick={onClick}
            >
                {content}
            </Component>
        );
    },
);
